import { isEqual, omit } from 'lodash-es';
import { getPath } from 'site-modules/personalized-search/utils/add-filters-to-query';
import { getQuery } from 'client/utils/location';

function getNewFilters(leadFormParams) {
  return {
    ...omit(leadFormParams, 'dealerlocationid'),
    ...(leadFormParams.dealerlocationid ? { rooftopId: leadFormParams.dealerlocationid } : {}),
  };
}

export const getLeadFormSrpLinkAttributes = ({ selectedFilters, onUpdateFilters, location }) => {
  const handleLinkClick =
    ({ leadFormParams, closeDrawer }) =>
    event => {
      event.preventDefault();
      closeDrawer?.();

      const newFilters = getNewFilters(leadFormParams);

      if (!isEqual(selectedFilters, newFilters)) {
        onUpdateFilters(newFilters);
      }
    };

  return ({ leadFormParams, closeDrawer }) => ({
    to: `${getPath({ pathname: location.pathname, query: getQuery(location), filters: getNewFilters(leadFormParams) })}`,
    onClick: handleLinkClick({ leadFormParams, closeDrawer }),
  });
};
